import Dropdown from 'antd/lib/dropdown'
import Tooltip from 'antd/lib/tooltip'
import { ActionButton } from 'Components/common/ActionButton/ActionButton'
import { ToolbarActionType } from 'Core/Workbench'
import classes from '../ActionsContainer.module.less'
import { DownArrow } from 'Components/common/Icons/DownArrow'

type ExpandedActionsPropsType = {
    expandedActions: ToolbarActionType[]
}

export const ExpandedActions = (props: ExpandedActionsPropsType) => {
    const { expandedActions } = props
    return (
        <>
            {expandedActions.map(action => {
                if (action.children) {
                    return (
                        <Dropdown
                            key={action.id}
                            menu={{
                                items: action.children.map(item => {
                                    return {
                                        key: item.id,
                                        label: item.title,
                                        onClick: item.onClick,
                                        disabled: item.disabled,
                                        icon: item.icon ? (
                                            <item.icon color={'#e65048'} />
                                        ) : undefined,
                                    }
                                }),
                            }}
                            trigger={['click']}
                            placement="bottomRight"
                            className={classes.dropdownBtn}
                            disabled={
                                typeof action.disabled === 'function'
                                    ? action.disabled()
                                    : action.disabled
                            }
                        >
                            <ActionButton
                                color={action.color}
                                title={action.title}
                                disabled={
                                    typeof action.disabled === 'function'
                                        ? action.disabled()
                                        : action.disabled
                                }
                                icon={DownArrow}
                                iconPosition="end"
                            />
                        </Dropdown>
                    )
                } else {
                    return (
                        <Tooltip
                            key={action.id}
                            placement="bottom"
                            trigger="hover"
                            title={action.tooltip}
                        >
                            <ActionButton
                                title={action.title}
                                icon={action.icon}
                                onClick={action.onClick}
                                color={action.color}
                                disabled={
                                    typeof action.disabled === 'function'
                                        ? action.disabled()
                                        : action.disabled
                                }
                            />
                        </Tooltip>
                    )
                }
            })}
        </>
    )
}
